import { useCallback } from 'react';
import useAuth from './useAuth';

const useMenuAccess = () => {
  const { user } = useAuth();

  return useCallback(
    (roles) => {
      const userRole = [user?.role];
      if (!roles) {
        return false;
      }

      const isAccess = roles.filter((ele) => userRole.some((item) => item === ele));
      return !!isAccess.length;
    },
    [user?.role]
  );
};
export default useMenuAccess;
